import { useNavigate } from 'react-router-dom';
import { Folder } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

import { ResourceCard, ResourceCardLogo } from 'components/blocks/resource-card';
import { configureCardSizeClassName } from 'constant/configure-layout';
import { VisibilityBadge } from 'components/blocks/visibility-field';
import type { IamData } from 'features/iam/services/user-service';
import type { PromptFolder } from '../types';
import { FolderActionDropdown } from './folder-action-dropdown';

type FolderRowProps = {
  folder: PromptFolder;
  owner?: IamData;
  onAddPrompt: (folder: PromptFolder) => void;
};

export function FolderRow({ folder, onAddPrompt }: FolderRowProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const folderDisplayName = folder.isDefault ? t('PRIVATE') || folder.name : folder.name;

  return (
    <ResourceCard
      title={folderDisplayName}
      icon={
        <ResourceCardLogo name={folderDisplayName}>
          <Folder width={20} height={20} strokeWidth={1.75} />
        </ResourceCardLogo>
      }
      actions={<FolderActionDropdown folder={folder} onAddPrompt={() => onAddPrompt(folder)} />}
      onSelect={() => navigate(`/prompts/${folder.id}`)}
      className={configureCardSizeClassName}
      footer={
        <div className="flex min-h-7 items-center justify-between gap-2">
          <div className="ml-auto flex min-w-0 shrink-0 items-center gap-1.5">
            <VisibilityBadge value={folder.visibility} className="shrink-0" uppercase={false} />
          </div>
        </div>
      }
    />
  );
}
